/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */

/*
 * This file should update the file on the Kweeder-ui-library
 *
 */

import axios from 'axios'
import { differenceInYears, isDate, isAfter, getYear } from 'date-fns'
import { helpers } from 'vuelidate/lib/validators'

const stringToDate = (string) => {
  if (string === null) {
    return null
  }

  if (!isStringDate(string)) {
    return null
  }

  const dateParts = string.split('/')
  return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
}

const isStringDate = (string) => {
  const pattern = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/

  return pattern.test(string)
}

const nifPattern = (value) => {
  if (value === null) {
    return false
  }

  const stringValue = String(value)

  if (stringValue.length !== 9) {
    return false
  }

  const firstNumber = stringValue.substring(0, 1) * 9
  const secondNumber = stringValue.substring(1, 2) * 8
  const thirdNumber = stringValue.substring(2, 3) * 7
  const fourNumber = stringValue.substring(3, 4) * 6
  const fiveNumber = stringValue.substring(4, 5) * 5
  const sixNumber = stringValue.substring(5, 6) * 4
  const sevenNumber = stringValue.substring(6, 7) * 3
  const eightNumber = stringValue.substring(7, 8) * 2
  const nineNumber = stringValue.substring(8, 9)

  let checkDigit
  const formula =
    parseFloat(
      firstNumber +
        secondNumber +
        thirdNumber +
        fourNumber +
        fiveNumber +
        sixNumber +
        sevenNumber +
        eightNumber
    ) % 11

  if (stringValue.length < 9) {
    return false
  }

  if (formula <= 1) {
    checkDigit = 0
  } else {
    checkDigit = 11 - formula
  }

  if (checkDigit !== parseInt(nineNumber, 10)) {
    return false
  }

  return true
}

const phoneNumber = (value) => {
  if (value === null) {
    return false
  }
  const stringValue = String(value)

  const firstNumber = parseInt(stringValue.substring(0, 1), 10)
  const secondNumber = parseInt(stringValue.substring(1, 2), 10)
  const validFirstNumbers = [9, 2]
  const validSecondNumbers = [1, 2, 3, 6]

  if (!validFirstNumbers.includes(firstNumber)) {
    return false
  }

  if (!validSecondNumbers.includes(secondNumber)) {
    return false
  }

  return true
}

const emailDomain = (value) => {
  const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!pattern.test(value)) {
    return false
  }

  return axios
    .get(`${process.env.CLIENT_API_URL}/check-email/is-valid/${value}`)
    .then(({ data }) => data.valid)
}

const zipCode = (value, vm) => {
  const pattern = /(^[0-9]{4}-[0-9]{3}$)/

  if (!pattern.test(value)) {
    return false
  }

  return axios
    .get(`${process.env.CLIENT_API_URL}/postal-code/${value}`)
    .then(({ data }) => {
      // vm.$data.postalCodeInfo = data.postalInfo.parish_name;
      return data.valid
    })
}

const licensePlate = (value) => {
  const pattern = /^(([A-Za-z]{2}-\d{2}-(\d{2}|[A-Za-z]{2}))|(\d{2}-(\d{2}-[A-Za-z]{2}|[A-Za-z]{2}-\d{2})))$/

  if (!pattern.test(value)) {
    return false
  }

  return true
}

const isLessThanToday = (value) => {
  if (stringToDate(value) == null) {
    return false
  }
  return !isAfter(stringToDate(value), new Date())
}

const isAtLeastAgo = (finalDate, numberOfYears) =>
  helpers.withParams(
    { type: 'isAtLeastAgo', finalDate, numberOfYears },
    (firstDate) => {
      if (!helpers.req(firstDate) || !isStringDate(firstDate)) {
        return false
      }

      const dateObj1 = isDate(firstDate) ? firstDate : stringToDate(firstDate)
      const dateObj2 = isDate(finalDate) ? finalDate : stringToDate(finalDate)
      const difference = differenceInYears(dateObj2, dateObj1)

      return difference >= numberOfYears
    }
  )
const isAtLeastAfter = (finalDate, numberOfYears) =>
  helpers.withParams(
    {
      type: 'isAtLeastAfter',
      finalDate,
      numberOfYears
    },
    (firstDate) => {
      if (firstDate === null) {
        return false
      }
      const dateObj1 = isDate(firstDate) ? firstDate : stringToDate(firstDate)
      const dateObj2 = isDate(finalDate) ? finalDate : stringToDate(finalDate)
      const difference = differenceInYears(dateObj1, dateObj2)

      return difference <= numberOfYears
    }
  )

const isBiggerThan = (elementName, numberOfYears) =>
  helpers.withParams(
    { type: 'isBiggerThan', elementName, numberOfYears },
    (value, vm) => {
      const elementValue = helpers.ref(elementName, this, vm)

      if (elementValue === null || elementValue === undefined) {
        return false
      }

      const elementNameDate = stringToDate(elementValue)
      const currentElementDate = stringToDate(value)
      const difference = differenceInYears(currentElementDate, elementNameDate)

      return difference >= numberOfYears
    }
  )
const isDateBetween = (elementName, finalDate) =>
  helpers.withParams(
    { type: 'isDateBetween', elementName, finalDate },
    (inputValue, vm) => {
      const elementValue = helpers.ref(elementName, this, vm)
      const dateObj1 = isDate(elementValue)
        ? elementValue
        : stringToDate(elementValue)
      // eslint-disable-next-line no-console
      const dateObj2 =
        finalDate instanceof Date ? finalDate : stringToDate(finalDate)
      const difference = Math.abs(differenceInYears(dateObj1, dateObj2))

      return difference >= inputValue
    }
  )

const isLessOrEqual = (elementName) => {
  helpers.withParams(
    {
      type: 'isLessOrEqual',
      elementName
    },
    (inputValue, vm) => {
      try {
        const elementValue = helpers.ref(elementName, this, vm)

        return inputValue <= elementValue
      } catch (error) {
        return false
      }
    }
  )
}

const isDateLessThan = (years) =>
  helpers.withParams({ type: 'isDateLessThan', years }, (inputValue) => {
    if (!helpers.req(inputValue) || !isStringDate(inputValue)) {
      return false
    }
    const elementYears = getYear(stringToDate(inputValue))
    const todayYear = getYear(new Date())

    return todayYear - elementYears < years
  })

export {
  nifPattern,
  emailDomain,
  phoneNumber,
  zipCode,
  licensePlate,
  isAtLeastAgo,
  isLessThanToday,
  isBiggerThan,
  isDateBetween,
  isLessOrEqual,
  isAtLeastAfter,
  isDateLessThan,
  stringToDate
}
